<template>
  <div>
    <!-- 弹出层n2n设备分组 -->
    <el-dialog :title="$t('lang.n2n.groupInfo')" :visible.sync="outerVisible" center width="80%">
      <el-table
        :data="GroupList"
        height="550"
        size="mini"
        @sort-change="sortChange"
        row-key="n2nInfoId"
        :header-cell-style="{background:'#e4f1ff'}">
        <el-table-column type="selection" min-width="40"></el-table-column>
        <el-table-column :label="$t('lang.n2n.groupName')" align="center" sortable="custom">
          <template slot-scope="scope">
            <el-input
              size="mini"
              v-if="scope.$index==0"
              :placeholder="$t('lang.n2n.groupName')"
              v-model="seek.groupName">
            </el-input>
            <span
              class="spanov font-style"
              :title="scope.row.groupName"
              v-if="scope.$index!==0">
              {{ scope.row.groupName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.n2n.customer')" align="center" sortable="custom">
          <template slot-scope="scope">
            <el-input
              size="mini"
              v-if="scope.$index==0"
              :placeholder="$t('lang.n2n.customer')"
              v-model="seek.customerName">
            </el-input>
            <span
              class="spanov font-style"
              :title="scope.row.customerName"
              v-if="scope.$index!==0">
              {{ scope.row.customerName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.n2n.username')" align="center" sortable="custom">
          <template slot-scope="scope">
            <el-input
              size="mini"
              v-if="scope.$index==0"
              :placeholder="$t('lang.n2n.username')"
              v-model="seek.username">
            </el-input>
            <span
              class="spanov font-style"
              :title="scope.row.username"
              v-if="scope.$index!==0">
              {{ scope.row.username }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.n2n.password')" align="center" sortable="custom">
          <template slot-scope="scope">
            <el-input
              size="mini"
              v-if="scope.$index==0"
              :placeholder="$t('lang.n2n.password')"
              v-model="seek.password">
            </el-input>
            <span
              class="spanov font-style"
              :title="scope.row.password"
              v-if="scope.$index!==0">
              {{ scope.row.password }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.n2n.ip')" align="center" sortable="custom">
          <template slot-scope="scope">
            <el-input size="mini" v-if="scope.$index==0" :placeholder="$t('lang.n2n.ip')" v-model="seek.ip"></el-input>
            <span class="spanov font-style" :title="scope.row.ip" v-if="scope.$index!==0">{{ scope.row.ip }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.n2n.remotePort')" align="center" sortable="custom">
          <template slot-scope="scope">
            <el-input size="mini" v-if="scope.$index==0" :placeholder="$t('lang.n2n.remotePort')" v-model="seek.port"></el-input>
            <span
              class="spanov font-style"
              :title="scope.row.port"
              v-if="scope.$index!==0">
              {{ scope.row.port }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.n2n.deivceNumber')" align="center" sortable="custom">
          <template slot-scope="scope">
            <el-input
              size="mini"
              v-if="scope.$index==0"
              :placeholder="$t('lang.n2n.deivceNumber')"
              v-model="seek.deviceNum">
            </el-input>
            <span
              class="spanov font-style"
              :title="scope.row.deviceNum"
              v-if="scope.$index!==0">
              {{ scope.row.deviceNum }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.TableComponent.operating')" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.$index!==0"
              type="primary"
              icon="icon-chaxun"
              @click="showDevices(scope.row)"
              circle>
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="GetN2nInfoId(scope.row.n2nInfoId)"
              circle
              v-if="scope.$index!==0">
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog width="30%" :title="$t('lang.n2n.migrate')" center :visible.sync="innerVisible" append-to-body>
        <div style="text-align:center">
          <p class="Group-Table-dialog-Title">{{$t('lang.n2n.original')}}</p>
          <br>
          <p>
            <span class="tetxp">n2n：</span>
            <!-- <el-input size="mini" class="admininput"></el-input> -->
            <el-input size="mini" class="admininput" v-model="N2nInformation.serverName" disabled></el-input>
          </p>
          <p>
            <span class="tetxp">{{$t('lang.n2n.version')}}：</span>
            <el-input
              size="mini"
              class="admininput"
              disabled
              v-model="N2nInformation.serverVersion">
            </el-input>
          </p>
          <p>
            <span class="tetxp">{{$t('lang.n2n.port')}}：</span>
            <el-input size="mini" class="admininput" disabled v-model="N2nInformation.serverPort"></el-input>
          </p>
          <br>
          <p class="Group-Table-dialog-Title">{{$t('lang.n2n.target')}}</p>
          <br>
          <p>
            <span class="tetxp">n2n：</span>
            <el-select
              v-model="value2"
              class="admininput"
              size="mini"
              @change="GetN2nServer">
              <el-option
                v-for="item in data"
                :key="item.serverId"
                :label="item.serverName"
                :value="item.serverId">
              </el-option>
            </el-select>
          </p>
          <p>
            <span class="tetxp">{{$t('lang.n2n.version')}}：</span>
            <el-input size="mini" class="admininput" disabled v-model="N2nData.serverVersion"></el-input>
          </p>
          <p>
            <span class="tetxp">{{$t('lang.n2n.port')}}：</span>
            <el-input size="mini" class="admininput" disabled v-model="N2nData.serverPort"></el-input>
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="innerVisible = false">{{$t('lang.Button.cancel')}}</el-button>
          <el-button size="mini" type="primary" @click="updateGroupInfo">{{$t('lang.Button.submit')}}</el-button>
        </span>
      </el-dialog>
      <pagination
        :total="total"
        :offset="offset"
        :limit="limit"
        @SizeChanges="SizeChanges"
        @CurrentChanges="CurrentChanges"
      ></pagination>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryKeywordGroupInfo,
  GetListN2nServer,
  updateGroupInfo
} from "@/api/remoteservice";
import { PublicComponent } from "@/mixins/common";
import pagination from "@/components/pagination";
export default {
  mixins: [PublicComponent],
  props: {
    serverId: Number,
    N2nInformation: Object
  },
  data() {
    return {
      //弹出层控制
      outerVisible: false,
      innerVisible: false,
      //n2n分组列表
      GroupList: [],
      options: [{ value: 0, label: this.$t('lang.n2n.originalN2N')}, { value: 1, label: this.$t('lang.n2n.targetN2N') }],
      value1: 0,
      value2: null,
      data: [],
      //目标服务选中n2n版本与端口信息
      N2nData: {},
      n2nInfoId: null,
      //搜索
      seek: {
        groupName: "",
        customerName: "",
        username: "",
        password: "",
        ip: "",
        port: "",
        deviceNum: ""
      },
      //排序
      sort: {
        groupName: null,
        customerName: null,
        username: null,
        password: null,
        ip: null,
        port: null,
        deviceNum: null
      }
    };
  },
  components: {
    pagination
  },
  methods: {
    //目标服务下拉框改变获取当前选中的n2n版本与端口信息
    GetN2nServer() {
      this.data.forEach((item, index) => {
        if (item.serverId === this.value2) {
          this.N2nData = item;
          return
        }
      });
    },
    //迁移分组所属服务
    updateGroupInfo() {
      this.$confirm(this.$t('lang.n2n.confirmTips'), this.$t('lang.Button.tips'), {
          confirmButtonText: this.$t('lang.Button.confirm'),
          cancelButtonText: this.$t('lang.Button.cancel'),
          type: 'warning',
          center: true
        }).then(() => {
          updateGroupInfo(
        [this.n2nInfoId],
        this.value2,
        parseInt(this.N2nData.serverPort)
      ).then(res => {
        this.queryKeyword()
        this.$emit('Getn2nList')
        if (res.data.code === 0) {
          this.$message({
            message: this.$t('lang.groupinglist.message15'),
            type: "success"
          });
        } else {
          this.$message({
            message: this.$t('lang.groupinglist.message16'),
            type: "warning"
          });
        }
      });
        })
        this.innerVisible = false;
    },
    //获取当前修改分组id and 显示弹框
    GetN2nInfoId(id) {
      this.n2nInfoId = id;
      this.innerVisible = true;
    },
    //排序
    sortChange({ column, prop, order }) {
      this.sort = {
        groupName: null,
        customerName: null,
        username: null,
        password: null,
        ip: null,
        port: null,
        deviceNum: null
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      switch (label) {
        case this.$t('lang.n2n.groupName'): {
          this.sort.groupName = sortlist;
          break;
        }
        case this.$t('lang.n2n.customer'): {
          this.sort.customerName = sortlist;
          break;
        }
        case this.$t('lang.n2n.username'): {
          this.sort.username = sortlist;
          break;
        }
        case this.$t('lang.n2n.password'): {
          this.sort.password = sortlist;
          break;
        }
        case this.$t('lang.n2n.ip'): {
          this.sort.ip = sortlist;
          break;
        }
        case this.$t('lang.n2n.remotePort'): {
          this.sort.port = sortlist;
          break;
        }
        case this.$t('lang.n2n.deivceNumber'): {
          this.sort.deviceNum = sortlist;
          break;
        }
      }
    },
    //获取分组列表与筛选
    queryKeyword(serverId = this.serverId) {
      queryKeywordGroupInfo(
        this.offset,
        this.limit,
        serverId,
        [
          this.seek.groupName,
          this.seek.customerName,
          this.seek.username,
          this.seek.password,
          this.seek.ip,
          this.seek.port,
          this.seek.deviceNum
        ],
        this.sort
      ).then(res => {
        this.GroupList = res.data.data.list;
        this.total = res.data.data.total;
        this.offset = res.data.data.offset;
        this.limit = res.data.data.limit;
        this.GroupList.unshift({});
      });
    },
    // 跳转到设备列表页
    showDevices(row) {
       // 分组跳转原来是传的分组id后面改成了传分组gid
      this.$store.dispatch("GetGroupingName", row.gid);
      this.outerVisible = false
      //跳转路由
      this.$router.push("/device/devicelist");
    }
  },
  watch: {
    serverId: {
      //通过serverId获取当前n2n下的分组
      handler(newValue, oldValue) {
        (this.N2nData = {}), (this.value2 = null);
        this.queryKeyword(newValue);
        GetListN2nServer(1, 99999).then(res => {
          this.data = res.data.data.list;
        });
      }
    }
  }
};
</script>
<style scoped>
.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}
.tetxp {
  display: inline-block;
  width: 2rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  text-align: right;
}
.admininput {
  display: inline-block;
  width: 4rem;
  margin: 0.2rem;
}
.Group-Table-dialog-Title {
  text-align: center;
  font-weight: bold;
}
.font-style{
  font-size: 0.25rem;
}
</style>
